export const exportKeys = {
  all: ["exports"] as const,
  list: (page: number, pageSize: number) =>
    [...exportKeys.all, "list", page, pageSize] as const,
  detail: (jobId: string) => [...exportKeys.all, "detail", jobId] as const,
};

export type InvoiceSearchKeyParams = {
  statuses?: string[];
  customerIds?: string[];
  pageSize: number;
  after?: string;
  createdFrom?: number;
  createdTo?: number;
  dueFrom?: number;
  dueTo?: number;
  amountDueMin?: number;
  amountDueMax?: number;
};

export const invoiceKeys = {
  all: ["invoices"] as const,
  search: (params: InvoiceSearchKeyParams) =>
    [...invoiceKeys.all, "search", params] as const,
};
